import IVenue from '../interfaces/IVenue';
import { useAPIV2 } from '../yoello-lib/modules/API2/useAPIv2';
import APIExtensions from '../yoello-lib/modules/API2/APIDefs';
import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";
export function useVenueData(venueId:string) {
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
    const { apiData: venueData } = useAPIV2<IVenue>(
        APIExtensions.venues,
        {
          query: venueId,
          canAPIGetCacheValue: true,
          selectorKeyParams: { venue_id: venueId },
          dispatcherParams: [venueId],
    
        }
      );
    const isSquare = venueData?.payment_processor === 'SQUARE';
    return {isSquare,isEposNow}
}